import { create } from 'zustand';
import { LocalStorageUtils } from '@shared/utils';
import type { User } from '@shared/api';

interface UseUserStore {
  data: User | null;
  setUser: (user: any) => void;
  clear: () => void;
}

export const useUserStore = create<UseUserStore>((set) => ({
  data: LocalStorageUtils.getUser(),

  setUser: async (user) => set({ data: user }),

  clear: () => set({ data: null }),
}));
